import { render, staticRenderFns } from "./GameGroups-Games.vue?vue&type=template&id=8e2e3284&scoped=true"
import script from "./GameGroups-Games.js?vue&type=script&lang=js&external"
export * from "./GameGroups-Games.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2e3284",
  null
  
)

export default component.exports